export default __webpack_public_path__ + "static/media/email-icon.62426b4c.svg";